// import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { Reply } from '@mui/icons-material';
import { Dialog, DialogActions, DialogContent, DialogTitle, Popover } from '@mui/material'; // <-- IMPORTANT: Imported Popover, removed Drawer
import React, { useState, useEffect } from "react";
import { Navigate, useNavigate,useLocation } from 'react-router-dom';

// The component name and props remain the same for a seamless replacement
export default function AnchorTemporaryDrawer({ onClickHandleReply }) {
  // --- MODIFIED STATE ---
  // We now use anchorEl for the Popover instead of the old 'state' object
  const [anchorEl, setAnchorEl] = useState(null);
  const [replyText, setReplyText] = useState("");
  const [loginDialogOpen, setLoginDialogOpen] = useState(false);

 const navigate = useNavigate();
  // const isAuthenticated = localStorage.getItem("isAuthenticated");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const query = params.get("isAuthenticated")?.toLowerCase() === "true";

    if (query) localStorage.setItem("isAuthenticated", "true");

    const local = localStorage.getItem("isAuthenticated") === "true";
    setIsAuthenticated(local);
  }, [location.search]);

  // --- MODIFIED HANDLERS ---
  const handleClick = (event) => {
    if (!isAuthenticated) {
      setLoginDialogOpen(true);
      return;
    }
    // Set the current button as the anchor for the popover to open from
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  // const navigate = useNavigate();
  const navigateLogin = () => {
    navigate("/login");
  }

  const handleSubmit = () => {
    if (!replyText.trim()) return;
    onClickHandleReply?.(replyText);
    setReplyText("");
    handleClose(); // Close the popover after submit
  };

  const open = Boolean(anchorEl);
  const id = open ? 'reply-popover' : undefined;

  // --- MODIFIED JSX ---
  return (
    <div>
      {/* This is the button that opens the popover */}
      <Button
        aria-describedby={id}
        variant="outlined"
        startIcon={<Reply sx={{
          fontSize: {
            xs: "0.9rem",
            sm: "1rem",
            md: "1.2rem",
          },
        }} />}
        size="small"
        onClick={handleClick}
        sx={{ borderRadius: 5 }}
      >
        Reply
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}

        PaperProps={{
          sx: {
            width: { xs: '90%', sm: '80%', md: 500 },
            maxWidth: '95vw',
            p: 2,
            boxSizing: 'border-box',
            bgcolor: '#212930',
            borderRadius: 5,
            boxShadow: '0 14px 12px 0 rgba(0, 0, 0, 0.2), 0 10px 25px 0 rgba(0, 0, 0, 0.19)',
            border: '1px solid #323d49'
          }
        }}
      >

        <Box>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Write a Reply
          </Typography>
          <TextField
            label="Your Comment"
            multiline
            rows={4}
            fullWidth
            value={replyText}
            onChange={(e) => setReplyText(e.target.value)}
          />
          <Divider sx={{ my: 2 }} />
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button onClick={handleClose}>Cancel</Button>
            <Button variant="contained" onClick={handleSubmit}>
              Post Reply
            </Button>
          </Box>
        </Box>
      </Popover>

      {/* The login dialog remains unchanged */}
      <Dialog open={loginDialogOpen} onClose={() => setLoginDialogOpen(false)}
        PaperProps={{
          sx: {
            bgcolor: '#212930',
            borderRadius: 5,
            boxShadow: '0 14px 12px 0 rgba(0, 0, 0, 0.2), 0 10px 25px 0 rgba(0, 0, 0, 0.19)',
            border: '1px solid #323d49',
          },
        }}
      >
        <DialogTitle>Login Required</DialogTitle>
        <DialogContent>
          <Typography>
            Please log in to interact with posts and comments.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLoginDialogOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={navigateLogin}>
            Login
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}